import ProjectUtils from "../../../../../../utils/project-utils.js";

export function makeCamerasItems(data) {
    const cameras = data?.dispatch ?? {};

    return [
        {
            label: "Motivo",
            value: cameras?.image_cause ?? "",
        },
        {
            label: "Solicitação anterior (protocolo do atendimento)",
            value: cameras?.image_attendance ?? "",
        },
        {
            label: "D/H do fato",
            value: ProjectUtils.formatDate(cameras?.image_dt_fact ?? "", null, true),
        },
    ];
}

export function makeCamerasTableItems(data) {
    const cameras = data?.dispatch?.cameras ?? [];

    return cameras.flatMap((camera, index) => [
        {
            label: "Câmera",
            value: camera.name ?? "",
        },
        {
            label: "D/H inicial da gravação",
            value: ProjectUtils.formatDate(camera.dt_start ?? "", null, true),
        },
        {
            label: "D/H final da gravação",
            value: ProjectUtils.formatDate(camera.dt_end ?? "", null, true),
        },
    ])
}